module.exports = __webpack_public_path__ + "media/images/page-prev-779bb15086f9b6d6e93a253ad845884a.svg";